import React from 'react';
import cx from 'classnames';
import styles from './MainSlider.module.scss';

const MainSliderPage = ({ children, current, ...rest }) => {
  return (
    <button
      type="button"
      className={cx(styles.page, { [styles.page_current]: current })}
      title={`Page ${children}`}
      {...rest}
    />
  );
};

export default MainSliderPage;
